import { render } from "./CDropdown.vue?vue&type=template&id=31e13bea"
import script from "./CDropdown.vue?vue&type=script&lang=js"
export * from "./CDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__